import axios from 'axios';

const API_URL = '/api/notes'

export const getNotes = async (user_id) => {
    const res = await axios.get(API_URL, {
        params: {user_id}
    });

    return res.data;
}

export const createNote = async ({user_id, preVisitNote, postVisitNote , appointment_date}) => {
    const res = await axios.post(API_URL, { user_id, preVisitNote, postVisitNote, appointment_date });

    return res.data;
}

export const deleteNote = async (id) => {
    const res = await axios.delete(`${API_URL}/${id}`);

    return res.data;
}

export const updateNote = async (id, { user_id, preVisitNote, postVisitNote, appointment_date}) => {
    const res = await axios.put(`${API_URL}/${id}`, { user_id, preVisitNote, postVisitNote, appointment_date });

    return res.data;
}